export default (name) => ({
  sent: false,

  scroll() {
    const viewOffset = this.$el.getBoundingClientRect();
    if (viewOffset.top < 210 && viewOffset.bottom > 200) {
      if (!this.sent) {
        this.sent = true;
        this.$dispatch('set-nav', name);
      }
    } else {
      this.sent = false;
    }
  },

  init() {},
});
